import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaGlobeAsia, FaMapMarkerAlt, FaSearch } from 'react-icons/fa';
import Breadcrumb from '../components/Breadcrumb.jsx';
import { setPageSEO } from '../utils/seo.js';
import { getRouteMetadata } from '../utils/seoMetadata.js';
import './Locations.css';

export const locations = [
  { region: 'Asia', country: 'India', cities: ['Ahmedabad', 'Amritsar', 'Bengaluru', 'Bhopal', 'Bhubaneswar', 'Chandigarh', 'Chennai', 'Coimbatore', 'Dehradun', 'Delhi', 'Faridabad', 'Ghaziabad', 'Goa', 'Gurugram', 'Guwahati', 'Hyderabad', 'Indore', 'Jaipur', 'Jalandhar', 'Jammu', 'Jamshedpur', 'Jodhpur', 'Kanpur', 'Kochi', 'Kolkata', 'Kozhikode', 'Lucknow', 'Ludhiana', 'Madurai', 'Mangaluru', 'Mumbai', 'Mysuru', 'Nagpur', 'Nashik', 'Noida', 'Patna', 'Pune', 'Raipur', 'Rajkot', 'Ranchi', 'Shimla', 'Surat', 'Thane', 'Thiruvananthapuram', 'Udaipur', 'Vadodara', 'Varanasi', 'Vijayawada', 'Visakhapatnam'] },
  { region: 'Asia', country: 'Singapore', cities: ['Singapore'] },
  { region: 'Asia', country: 'Malaysia', cities: ['Kuala Lumpur', 'George Town', 'Johor Bahru', 'Kota Kinabalu', 'Malacca', 'Ipoh'] },
  { region: 'Asia', country: 'Indonesia', cities: ['Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Semarang', 'Denpasar', 'Makassar'] },
  { region: 'Asia', country: 'Philippines', cities: ['Manila', 'Quezon City', 'Cebu City', 'Davao City', 'Makati', 'Pasig'] },
  { region: 'Asia', country: 'Japan', cities: ['Tokyo', 'Osaka', 'Kyoto', 'Yokohama', 'Nagoya', 'Sapporo', 'Fukuoka'] },
  { region: 'Asia', country: 'South Korea', cities: ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju'] },
  { region: 'Middle East', country: 'United Arab Emirates', cities: ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Al Ain'] },
  { region: 'Middle East', country: 'Saudi Arabia', cities: ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam', 'Khobar'] },
  { region: 'Middle East', country: 'Qatar', cities: ['Doha', 'Al Rayyan', 'Al Wakrah', 'Lusail'] },
  { region: 'Europe', country: 'United Kingdom', cities: ['London', 'Birmingham', 'Manchester', 'Leeds', 'Glasgow', 'Edinburgh', 'Liverpool', 'Bristol'] },
  { region: 'Europe', country: 'Ireland', cities: ['Dublin', 'Cork', 'Galway', 'Limerick', 'Waterford'] },
  { region: 'Europe', country: 'Germany', cities: ['Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt', 'Stuttgart', 'Dusseldorf'] },
  { region: 'Europe', country: 'France', cities: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Bordeaux', 'Lille'] },
  { region: 'Europe', country: 'Spain', cities: ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Malaga', 'Bilbao'] },
  { region: 'Europe', country: 'Italy', cities: ['Rome', 'Milan', 'Naples', 'Turin', 'Florence', 'Bologna'] },
  { region: 'Europe', country: 'Netherlands', cities: ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven'] },
  { region: 'North America', country: 'United States', cities: ['New York City', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas', 'Austin', 'San Francisco', 'Seattle', 'Boston', 'Miami'] },
  { region: 'North America', country: 'Canada', cities: ['Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Edmonton', 'Ottawa', 'Winnipeg', 'Halifax'] },
  { region: 'North America', country: 'Mexico', cities: ['Mexico City', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'Merida'] },
  { region: 'Oceania', country: 'Australia', cities: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Canberra', 'Gold Coast'] },
  { region: 'Oceania', country: 'New Zealand', cities: ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga', 'Dunedin'] },
  { region: 'Africa', country: 'South Africa', cities: ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Gqeberha', 'Bloemfontein'] },
  { region: 'Africa', country: 'Nigeria', cities: ['Lagos', 'Abuja', 'Kano', 'Ibadan', 'Port Harcourt', 'Benin City'] },
  { region: 'Africa', country: 'Kenya', cities: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret'] },
  { region: 'South America', country: 'Brazil', cities: ['Sao Paulo', 'Rio de Janeiro', 'Brasilia', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Curitiba'] },
  { region: 'South America', country: 'Argentina', cities: ['Buenos Aires', 'Cordoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata'] }
];

export function getCityPath(city) {
  return `/locations/${encodeURIComponent(city.replace(/\s+/g, '-'))}`;
}

export function getCityLocation(citySlug) {
  const cityName = decodeURIComponent(citySlug || '').replace(/-/g, ' ').toLowerCase();

  for (const location of locations) {
    const city = location.cities.find((candidate) => candidate.toLowerCase() === cityName);

    if (city) {
      return { ...location, city };
    }
  }

  return null;
}

function Locations() {
  const [query, setQuery] = useState('');

  useEffect(() => setPageSEO(getRouteMetadata('/locations')), []);

  const normalizedQuery = query.trim().toLowerCase();
  const filteredLocations = locations.reduce((results, location) => {
    const countryMatches = location.country.toLowerCase().includes(normalizedQuery);
    const cities = countryMatches || !normalizedQuery
      ? location.cities
      : location.cities.filter((city) => city.toLowerCase().includes(normalizedQuery));

    if (countryMatches || cities.length > 0) {
      results.push({ ...location, cities });
    }

    return results;
  }, []);

  const regions = [...new Set(filteredLocations.map((location) => location.region))];

  return (
    <main className="locations-page">
      <div className="locations-breadcrumb">
        <div className="container"><Breadcrumb currentLabel="Locations" /></div>
      </div>

      <section className="locations-hero">
        <div className="container locations-hero-grid">
          <div>
            <span className="locations-eyebrow">GLOBAL CUSTOMER PROOF</span>
            <h1>Customer testimonial software and widgets by location</h1>
            <p>Collect customer stories wherever your business and customers are based. Clientalio works online across every city in the countries below.</p>
            <label className="locations-search">
              <FaSearch aria-hidden="true" />
              <span className="sr-only">Search countries and cities</span>
              <input
                type="search"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Search India, Mumbai, London..."
              />
            </label>
          </div>
          <aside className="locations-hero-summary">
            <FaGlobeAsia aria-hidden="true" />
            <strong>{locations.length} countries</strong>
            <span>All cities supported nationwide</span>
            <p>Use one platform to request, review, organize, and publish video, text, and audio testimonials.</p>
          </aside>
        </div>
      </section>

      <section className="locations-directory" aria-live="polite">
        <div className="container">
          {filteredLocations.length > 0 ? regions.map((region) => (
            <div className="locations-region" key={region}>
              <div className="locations-region-heading">
                <span>{region}</span>
                <h2>{region} locations</h2>
              </div>
              <div className="locations-country-grid">
                {filteredLocations.filter((location) => location.region === region).map((location) => (
                  <article className="locations-country" key={location.country}>
                    <div className="locations-country-heading">
                      <FaMapMarkerAlt aria-hidden="true" />
                      <div><h3>{location.country}</h3><p>All cities in {location.country}</p></div>
                    </div>
                    <ul>
                      {location.cities.map((city) => (
                        <li key={city}><Link to={getCityPath(city)}>{city}</Link></li>
                      ))}
                    </ul>
                  </article>
                ))}
              </div>
            </div>
          )) : (
            <div className="locations-empty">
              <h2>No location found</h2>
              <p>Clientalio is web-based and may still work in your location. Contact us and we will help confirm availability.</p>
              <Link to="/contact">Contact support</Link>
            </div>
          )}
        </div>
      </section>

      <section className="locations-cta">
        <div className="container locations-cta-inner">
          <div><span>WORK FROM ANYWHERE</span><h2>Turn local customer stories into worldwide trust.</h2><p>Create a branded request and start collecting authentic customer proof today.</p></div>
          <Link to="/signup">Start collecting for free <FaArrowRight /></Link>
        </div>
      </section>
    </main>
  );
}

export default Locations;